import { IClipboardManager, StoredValue } from '@trackman/baseball-shared-components';
import { NotificationType } from 'interfaces/template/INotification';
import { makeObservable, observable } from 'mobx';
import SnackbarStore from 'stores/SnackbarStore';

export class ClipboardService<Value> implements IClipboardManager<Value> {
  storedValue: Value | StoredValue | null = null;

  storedDataKey: string;

  snackbarStore: SnackbarStore;

  constructor(snackbarStore: SnackbarStore) {
    this.snackbarStore = snackbarStore;
    this.storedDataKey = '';

    makeObservable(this, {
      storedValue: observable,
    });
  }

  save = (value: Value | StoredValue | null, dataKey: string) => {
    this.storedValue = value;
    this.storedDataKey = dataKey;
  };

  load = (): Value | StoredValue | null => {
    return this.storedValue;
  };

  validateCompatibility = (firstObject: any, secondObject: any, targetDataKey: string): boolean => {
    if (this.storedDataKey === targetDataKey) {
      return true;
    }

    if (
      (typeof firstObject === 'object' && typeof secondObject === 'string') ||
      (typeof firstObject === 'object' && typeof secondObject === 'number') ||
      (typeof firstObject === 'string' && typeof secondObject === 'object') ||
      (typeof firstObject === 'number' && typeof secondObject === 'object')
    ) {
      this.snackbarStore.pushNotification('Paste failed: value is not compatible with target column type', NotificationType.error);

      return false;
    }

    if (typeof firstObject === 'object' && typeof secondObject === 'object' && firstObject !== null && secondObject !== null) {
      const firstKeys = Object.keys(firstObject);
      const secondKeys = Object.keys(secondObject);

      if (firstKeys.length !== secondKeys.length) {
        this.snackbarStore.pushNotification('Paste failed: value is not compatible with target column type', NotificationType.error);

        return false;
      }

      for (const key of firstKeys) {
        if (!secondKeys.includes(key)) {
          this.snackbarStore.pushNotification('Paste failed: value is not compatible with target column type', NotificationType.error);

          return false;
        }
      }
    }

    return true;
  };
}
